import React from "react";
import Footer from "../Component/Footer/Footer";
import { useSelector } from "react-redux";
import Header from "../Component/Header/Header";
import AboutBanner from "Pages/About/AboutBanner";
import AboutPage from "Pages/About/about";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function AboutTheme() {
  //
  const { settings } = useSelector((state) => state?.Login);
  return (
    <>
      <Header />
      <AboutBanner data={settings?.AboutSetting} />
      <AboutPage />
      <Latestupdate />
      <Footer />
    </>
  );
}
